<template>
    <div class="root" v-loading="loading">

        
      <topmenu></topmenu>

        <!-- content -->

        <div class="container theme-showcase">

            <div style="margin-top: 20px; display: flex; align-items: center;">
                <div>
                    <el-page-header @back="goBack" title="Back">
</el-page-header>
                </div>
                <!-- <div>
                    <el-radio-group v-model="radioStep" size="medium" @input="stepChange">
                    <el-radio-button label="1">Basic</el-radio-button>
                    <el-radio-button label="2">Fields</el-radio-button>
                    <el-radio-button label="3">Visitor Category</el-radio-button>
                    <el-radio-button label="4">Badge</el-radio-button>
                    <el-radio-button label="5">Email Template</el-radio-button>
                </el-radio-group>
                </div> -->
                
            </div>

            <div style="border: 1px #f1f1f1 solid; margin: 12px 0; padding:30px 12px;">
                <el-form ref="form" :model="form" label-width="180px">
                    <el-form-item label="Event Name:" required error="">
                        <el-input v-model="eventname"></el-input>
                    </el-form-item>
                    <el-form-item label="Event start date:">
                        <el-date-picker v-model="eventstartdate" type="date" 
                        placeholder="Pick a day"  >
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="Event end date:">
                        <el-date-picker v-model="eventenddate" type="date" placeholder="Pick a day">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="Text displayed after registration:">
                        <el-input type="textarea" v-model="finishtext"></el-input>
                        <div style="margin-top: 4px;">
                            <el-button size="mini" @click="showEditor(1)">editor</el-button>
                        </div>
                    </el-form-item>
                    <el-form-item label="Event Address:">
                        <el-input v-model="address"></el-input>
                    </el-form-item>

                    <el-form-item label="">
                        <div slot="label">
                            <span>Can be edit</span>
                            <el-tooltip class="item" effect="dark"
                                content="Whether users can edit again after registration." placement="top">
                                <span><i class="el-icon-info"></i></span>
                            </el-tooltip>
                            <span>:</span>
                        </div>
                        <el-switch v-model="canbeedit" @change="canbeeditChange"></el-switch>
                    </el-form-item>

                    <el-form-item label="Date Format">
                        <el-select v-model="dateformat" placeholder="Select Date Format">
                            <el-option label="yyyy/MM/dd" value="yyyy/MM/dd"></el-option>
                            <el-option label="yyyy.MM.dd" value="yyyy.MM.dd"></el-option>
                            <el-option label="MM/dd/yyyy" value="MM/dd/yyyy"></el-option>
                            <el-option label="MM.dd.yyyy" value="MM.dd.yyyy"></el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="Field Display Type">
                        <el-select v-model="fieldDefDisplayType" placeholder="Select">
                            <el-option label="Single" value="1"></el-option>
                            <el-option label="List" value="2"></el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="">
                        <div slot="label">
                            <span>Closing text</span>
                            <el-tooltip class="item" effect="dark" content="The text displayed after closing."
                                placement="top">
                                <span><i class="el-icon-info"></i></span>
                            </el-tooltip>
                            <span>:</span>
                        </div>

                        <el-input type="textarea" v-model="endtxt"></el-input>
                    </el-form-item>

                    <el-form-item label="Agreement:">
                        <el-input type="textarea" v-model="agreement"></el-input>
                    </el-form-item>

                    <el-form-item label="Top image:">
                        <div style="display: flex; align-items:center;">
                            <div>
                                <el-upload class="avatar-uploader" action="#" :http-request="topimgUpload"
                                    :show-file-list="false">
                                    <img v-if="topimg != ''" :src="topimg" class="avatar">
                                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                </el-upload>
                            </div>
                            <div style="margin-left: 22px;">
                                <el-button v-if="topimg != ''" @click="deltopimg" type="danger" icon="el-icon-delete" circle></el-button>
                            </div>
                        </div>

                    </el-form-item>

                    <el-form-item label="Top image width:" required error="">
                        <el-input v-model="topImgWidth" type="number"></el-input>
                    </el-form-item>

                    <el-form-item label="Bottom image:">
                        <div style="display: flex; align-items:center;">
                            <div>
                                <el-upload class="avatar-uploader" action="#" :http-request="btmimgUpload"
                                    :show-file-list="false">
                                    <img v-if="btmimg != ''" :src="btmimg" class="avatar">
                                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>

                                </el-upload>
                            </div>
                            <div style="margin-left: 22px;">
                                <el-button v-if="btmimg != ''" @click="delbtmimg" type="danger" icon="el-icon-delete" circle></el-button>
                            </div>
                        </div>

                    </el-form-item>
                    
                    <el-form-item label="Bottom image width:" required error="">
                        <el-input v-model="bottomImgWidth" type="number"></el-input>
                    </el-form-item>
                    
                    
                    <el-form-item label="Background Css:">
                        <el-input v-model="BgCss"></el-input>
                    </el-form-item>

                    <el-divider></el-divider>

                    <el-form-item label="Form Width:">
                        <el-input v-model="FormWidth"></el-input>
                    </el-form-item>
                    <el-form-item label="Form MarginTop:">
                        <el-input type="number" v-model="FormMarginTop"></el-input>
                    </el-form-item>
                    <el-form-item label="Form MarginBtm:">
                        <el-input type="number" v-model="FormMarginBtm"></el-input>
                    </el-form-item>

                    <el-divider></el-divider>

                    <el-form-item label="SubmitBtn Text:">
                        <el-input v-model="SubmitBtnText"></el-input>
                    </el-form-item>
                    <el-form-item label="SubmitBtn Bg Color:">
                        <el-input v-model="SubmitBtnBgColor"></el-input>
                    </el-form-item>

                    <el-divider></el-divider>
                    <el-form-item label="Email Address:">
                        <el-input v-model="emailaddress"></el-input>
                    </el-form-item>
                    <el-form-item label="Email Display Name:">
                        <el-input v-model="emailDisplayName"></el-input>
                    </el-form-item>
                    <el-form-item label="Email ReplyTo:">
                        <el-input v-model="emailReplyTo"></el-input>
                    </el-form-item>
                    <el-form-item label="Email Bcc:">
                        <el-input v-model="emailBcc"></el-input>
                    </el-form-item>
                    <el-form-item label="Email SmtpPort:">
                        <el-input v-model="emailSmtpPort"></el-input>
                    </el-form-item>
                    <el-form-item label="Email Use Default Credentials:">
                        <el-input v-model="emailUseDefaultCredentials"></el-input>
                    </el-form-item>
                    <el-form-item label="Email Enable Ssl:">
                        <el-input v-model="emailEnableSsl"></el-input>
                    </el-form-item>
                    <el-form-item label="Email UserName:">
                        <el-input v-model="emailUserName"></el-input>
                    </el-form-item>
                    <el-form-item label="Email Password:">
                        <el-input v-model="emailPassword"></el-input>
                    </el-form-item>
                    <el-form-item label="Email SmtpHost:">
                        <el-input v-model="emailSmtpHost"></el-input>
                    </el-form-item>

                    <el-form-item>
                        <el-button type="primary" :disabled="btnDis" @click="onSubmit">Save</el-button>
                    </el-form-item>
                </el-form>
            </div>
            <div style="height: 35px;"></div>
        </div>


        <el-dialog title="Editor" width="60%" :visible.sync="dialogTableVisible">
            <div>
                <div style="border: 1px solid #ccc;">
                    <Toolbar style="border-bottom: 1px solid #ccc" :editor="editor" :defaultConfig="toolbarConfig"
                        :mode="mode" />
                    <Editor style="height: 500px; overflow-y: hidden;" v-model="html" :defaultConfig="editorConfig"
                        :mode="mode" @onCreated="onCreated" />
                </div>

                <div>

<div class="mylabel" style="font-weight: bold;">Insert: </div>
<div style="line-height: 40px; background-color: #f1f1f1; padding: 12px;">
    <div style="display: flex; margin-bottom: 12px;">
        <div style="">Qrcode: </div>
        <div>
            <el-button @click="insetQr" size="small">Qrcode</el-button>
        </div>
        <div style="margin-left: 20px;">
            <el-input v-model="qrcodewidth"  size="small" type="number" @input="qrcodeWidthChange" placeholder="Qrcode width"></el-input>
        </div>
    </div>

    <div style="display: flex; ">
        <div style="width:60px;">Fields:</div>
        <div style="">
            <div style="display: inline-block; margin:0 5px 1px 0; ">
                <el-button @click="insetFd('Event Name')" size="small">Event Name</el-button>
            </div>
            <div style="display: inline-block; margin:0 5px 1px 0; ">
                <el-button @click="insetFd('Event start date')" size="small">Event start date</el-button>
            </div>
            <div style="display: inline-block; margin:0 5px 1px 0; ">
                <el-button @click="insetFd('Event end date')" size="small">Event end date</el-button>
            </div>
            <div style="display: inline-block; margin:0 5px 1px 0; ">
                <el-button @click="insetFd('Event Address')" size="small">Event Address</el-button>
            </div>
        </div>
    </div>

    <div style="display: flex; ">
        <div style="width:80px;">Fields:</div>
        <div >
            <div v-for="item in fieldlist" :key="item.id"
                style="display: inline-block; margin:0 5px 1px 0; ">
                <el-button @click="insetFd(item.FieldName)" size="small">{{ item.FieldName
                }}</el-button>
            </div>
        </div>
    </div>
</div>
</div>

            </div>
            <div style="text-align: center; margin-top: 12px;">
                <el-button size="medium" @click="dialogTableVisible=false;">Cancel</el-button>
                <el-button size="medium" type="primary" @click="saveEditorHtml">Save</el-button>
            </div>
        </el-dialog>

        <!-- content -->

    </div>
</template>

<script>

import axios from 'axios'
import topmenu from '../home/components/topmenu'
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import { i18nChangeLanguage } from '@wangeditor/editor'
i18nChangeLanguage('en')

export default {
    name: 'eventlist',
    data: function () {
        return {
            id:0,
            btnDis:false,
            radioStep: '1',
            nickname: '',
            loading: false,
            form: {
                
            },
            qrcodewidth:'',
            agreement:'',
            finishtext:'',
            fieldDefDisplayType:'',
            dateformat:'',
            canbeedit:false,
            endtxt:'',
            address: '',
            eventname:'',
            topimg: '',
            btmimg: '',
            eventstartdate:'',
            eventenddate:'',
            emailaddress:'',
            emailDisplayName:'',
            emailReplyTo:'',
            emailSmtpPort:'',
            emailBcc:'',
            emailUseDefaultCredentials:'',
            emailEnableSsl:'',
            emailUserName:'',
            emailPassword:'',
            emailSmtpHost:'',

            SubmitBtnText:'',
            SubmitBtnBgColor:'',
            SubmitBtnBgImg:'',
            BgImg:'',
            BgCss:'',
            topImgWidth:0,
            bottomImgWidth:0,
            FormWidth:'',
            FormMarginTop:'',
            FormMarginBtm:'',
            eidtorIndex:0,
            dialogTableVisible:false,

            fieldlist: [],
            editor: null,
            html: '',
            qrcodewidth:'',
            toolbarConfig: {},
            editorConfig: { placeholder: 'email content...', MENU_CONF: {
                uploadImage:{
                    base64LimitSize: 10 * 1024, // 10kb
                    // server: server_url+'/api/UploadFile/VisitorUpLoadOneImg?type=510',
                }
            }},
            mode: 'default', // or 'simple'
        }
    },
    components: {
        topmenu,
        Editor, Toolbar,
    },
    methods: {
        insetQr() {
            this.editor.insertText('{{Qrcode}}');
        },
        insetFd(fd) {
            this.editor.insertText('{{' + fd + '}}');
        },
        qrcodeWidthChange(){
            
        },
        saveEditorHtml(){
            var index = this.eidtorIndex;
            if(index==1){
                var html = this.editor.getHtml();
                this.finishtext = html;
                this.dialogTableVisible=false;
            }
        },
        onCreated(editor) {
            console.log('onCreated');
            this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
        },
        showEditor(index){
            this.eidtorIndex=index;
            this.dialogTableVisible=true;
            if(index==1){
                setTimeout(() => {
                this.editor.setHtml(this.finishtext);
                }, 1000);
            }
        },
        goBack(){
this.$router.back();
        },
        canbeeditChange(step) {
            console.log(step);
        },
        topimgUpload(data) {
            var formData = new FormData();
            formData.append("file", data.file);
            var userJson = JSON.parse(localStorage.getItem('userJson'));
            console.log(userJson);
            var uid = userJson.uid;
            var token = userJson.token;
            console.log(uid);
            console.log(token);
            axios.post('api/UploadFile/UpLoadOneImg?uid=' + uid + '&token=' + token + '&type=110',
                formData
            )
                .then(this.topimgUploadSucc)
        },
        topimgUploadSucc(res) {
            res = res.data
            console.log(res);
            if (res && res.Code == 200) {
                this.topimg = res.fileUrl;
                // this.$set(this.form,'topimg',res.fileUrl);
            } else {
                if (res && res.Code == 301) {
                    localStorage.removeItem('userJson');
                    this.$router.replace('/login');
                }
            }
        },

        btmimgUpload(data) {
            var formData = new FormData();
            formData.append("file", data.file);
            var userJson = JSON.parse(localStorage.getItem('userJson'));
            console.log(userJson);
            var uid = userJson.uid;
            var token = userJson.token;
            console.log(uid);
            console.log(token);
            axios.post('api/UploadFile/UpLoadOneImg?uid=' + uid + '&token=' + token + '&type=120',
                formData
            )
                .then(this.btmimgUploadSucc)
        },
        btmimgUploadSucc(res) {
            res = res.data
            console.log(res);
            if (res && res.Code == 200) {
                this.btmimg = res.fileUrl;
                // this.$set(this.form,'topimg',res.fileUrl);
            } else {
                if (res && res.Code == 301) {
                    localStorage.removeItem('userJson');
                    this.$router.replace('/login');
                }
            }
        },

        loadFields() {
            this.loading = true;
            var userJson = JSON.parse(localStorage.getItem('userJson'));
            axios.post('/api/Fields/getFieldsList',
                {
                    eventId: this.id,
                    uid: userJson.uid,
                    token: userJson.token
                }
            )
                .then(this.loadFieldsSucc)
        },
        loadFieldsSucc(res) {
            this.loading = false;
            res = res.data
            console.log(res);
            if (res && res.Code == 200) {
                this.fieldlist = res.list;
            } else {
                if (res && res.Code == 301) {
                    localStorage.removeItem('userJson');
                    this.$router.replace('/login');
                }
            }
        },

        delbtmimg() {
            this.btmimg='';
        },
        deltopimg() {
            this.topimg='';
        },

        toeventlist() {
            this.$router.back();
        },
        onSubmit() {
            this.loading = true;
            this.btnDis= true;
            var userJson = JSON.parse(localStorage.getItem('userJson'));
            
            var uid = userJson.uid;
            var token = userJson.token;
            axios.post('api/Event/editInfo',
                {
                    uid: uid,
                    token: token,
                    id:this.id,
                    eventName:this.eventname,
                    address:this.address,
                    beginDT:this.eventstartdate,
                    endDt:this.eventenddate,
                    endTxt:this.endtxt,
                    finishTxt:this.finishtext,
                    agreement:this.agreement,
                    topimgUrl:this.topimg,
                    bottomImgUrl:this.btmimg,
                    userCanEdit:this.canbeedit,
                    DateFormat:this.dateformat,
                    FieldDefDisplayType:this.fieldDefDisplayType,
                    EmailAddr:this.emailaddress,
                    EmailDisplayName:this.emailDisplayName,
                    EmailReplyTo:this.emailReplyTo,
                    EmailBcc:this.emailBcc,
                    SmtpPort:this.emailSmtpPort,
                    EmailUseDefaultCredentials:this.emailUseDefaultCredentials,
                    EmailEnableSsl:this.emailEnableSsl,
                    EmailUserName:this.emailUserName,
                    EmailPassword:this.emailPassword,
                    SmtpHost:this.emailSmtpHost,

                    SubmitBtnText:this.SubmitBtnText,
            SubmitBtnBgColor:this.SubmitBtnBgColor,
            SubmitBtnBgImg:this.SubmitBtnBgImg,
            BgImg:this.BgImg,
            BgCss:this.BgCss,
            bottomImgWidth:this.bottomImgWidth,
            topImgWidth:this.topImgWidth,
            FormWidth:this.FormWidth,
            FormMarginTop:this.FormMarginTop,
            FormMarginBtm:this.FormMarginBtm,
                }
            )
                .then(this.submitSucc)
        },
        submitSucc(res) {
            this.loading = false;
            res = res.data
            console.log(res);
            if (res && res.Code == 200) {
                this.$message({
          message: 'Success!',
          type: 'success',
          onClose:()=>{
            this.$router.back();
          }
        });
            } else {
                if (res && res.Code == 301) {
                    localStorage.removeItem('userJson');
                    this.$router.replace('/login');
                }
            }
        },

        stepChange(step) {
            console.log(step);
        },
        loadData(id) {
            this.loading = true;
            var userJson = JSON.parse(localStorage.getItem('userJson'));
            axios.post('/api/event/getList',
                {
                    id:id,
                    uid: userJson.uid,
                    token: userJson.token
                }
            )
                .then(this.loadDataSucc)
        },
        loadDataSucc(res) {
            this.loading = false;
            res = res.data
            console.log(res);
            if (res && res.Code == 200) {
                if(res.list && res.list.length>0){
                    var item = res.list[0];
                    console.log(item);
                    this.eventname=item.eventName,
                    this.address=item.address,
                    this.eventstartdate=item.beginDT,
                    this.eventenddate=item.endDt,
                    this.endtxt=item.endTxt,
                    this.finishtext=item.finishTxt,
                    this.agreement=item.agreement,
                    this.topimg=item.topimgUrl,
                    this.btmimg=item.bottomImgUrl,
                    this.canbeedit=item.userCanEdit,
                    this.dateformat=item.DateFormat,
                    this.fieldDefDisplayType=item.FieldDefDisplayType,
                    this.emailaddress=item.EmailAddr,
                    this.emailDisplayName=item.EmailDisplayName,
                    this.emailReplyTo=item.EmailReplyTo,
                    this.emailBcc=item.EmailBcc,
                    this.emailSmtpPort=item.SmtpPort,
                    this.emailUseDefaultCredentials=item.EmailUseDefaultCredentials,
                    this.emailEnableSsl=item.EmailEnableSsl,
                    this.emailUserName=item.EmailUserName,
                    this.emailPassword=item.EmailPassword,
                    this.emailSmtpHost=item.SmtpHost,

                    this.SubmitBtnText=item.SubmitBtnText,
            this.SubmitBtnBgColor=item.SubmitBtnBgColor,
            this.SubmitBtnBgImg=item.SubmitBtnBgImg,
            this.BgImg=item.BgImg,
            this.BgCss=item.BgCss,
            this.topImgWidth=item.topImgWidth,
            this.bottomImgWidth = item.bottomImgWidth,
            this.FormWidth=item.FormWidth,
            this.FormMarginTop=item.FormMarginTop,
            this.FormMarginBtm=item.FormMarginBtm
                }
            } else {
                if (res && res.Code == 301) {
                    localStorage.removeItem('userJson');
                    this.$router.replace('/login');
                }
            }
        },

        handleCommand(command) {
            if (command == 'logout') {
                localStorage.removeItem('userJson');
                this.$router.replace('/login');
            }
        },
    },
    mounted() {
        const id = this.$route.query.id;
        console.log(id)
        this.id = id;
        if(id!=undefined&&id!=''){
        this.loadData(id)
        }
        
        this.loadFields();
        var userJson = JSON.parse(localStorage.getItem("userJson"));
        console.log(userJson);
        var nickname = userJson['nickname'];
        this.nickname = nickname;
        console.log(this.nickname);
    },
    beforeDestroy() {
        const editor = this.editor
        if (editor == null) return
        editor.destroy() // 组件销毁时，及时销毁编辑器
    }
}
</script>
<style src="@wangeditor/editor/dist/css/style.css"></style>
<style scoped>
.avatar-uploader>>>.el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader>>>.el-upload:hover {
    border-color: #409EFF;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 128px;
    height: 128px;
    line-height: 128px;
    text-align: center;
}

.avatar {
    width: 128px;
    display: block;
}

.root >>> .topmenuitem:nth-child(2){
    color: #fff;
 background-color: #080808;
}

</style>



// WEBPACK FOOTER //
// src/pages/eventlist/addevent.vue